import React from "react";
import ReactLoading from "react-loading";

import loadingAnimationWhite from "assets/img/loading-animation-white.gif";
import loadingAnimation from "assets/img/loading-animation.gif";
import { isIe } from "utils/helpers";

interface LoadingProps {
  width?: number;
  height?: number;
  color?: string;
  custom?: boolean;
  paddingTop?: string;
}

const SmallLoader: React.FC<LoadingProps> = ({
  width = 40,
  height = 40,
  color = "#E5B611",
  custom = false,
  paddingTop = "160px",
}) => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",

      // increased padding to look like no-data image spacing
      paddingTop: custom ? "0px" : paddingTop,
      paddingBottom: custom ? "0px" : "160px",

      width: "100%",
      boxSizing: "border-box",
    }}
  >
    {!isIe && (
      <ReactLoading type="spin" color={color} height={height} width={width} />
    )}

    {isIe && (
      <img
        src={color === "#fff" ? loadingAnimationWhite : loadingAnimation}
        alt="Loading..."
        style={{ width, height }}
      />
    )}
  </div>
);

export default SmallLoader;
